export default __webpack_public_path__ + "static/3-14-0-0-67bf81de2ce2db82b083ca65f56533aa.jpg";